<div class="d-flex align-items-center">
    <span class="font-weight-bold uppercase font-3 mr-2" style="margin-top: 2px">Download Ordered Items</span>
<!--    <button class="btn btn-icon large with-border with-shadow background-white mr-3" title="Export to Excel" (click)="exportToExcel()"><i class="fal fa-file-excel"></i></button>-->
<!--    <button class="btn btn-icon large with-border with-shadow background-white" title="Export to PDF" (click)="exportToPDF()"><i class="fal fa-file-pdf"></i></button>-->
</div>
